<template>
  <ItemTable
    ref="itemTable"
    :collectionFilters="getCollectionFilters"
    :columns="columns"
    :details="details"
    :disableBoundCount="disableBoundCount"
    :emptyCollectionMessage="emptyCollectionMessage"
    :idField="idField"
    :inDetailsAsidePanel="inDetailsAsidePanel"
    :inPanel="inPanel"
    :itemType="itemType"
    :legacyRowStyles="legacyRowStyles"
    :showSearchForm="showSearchForm"
    :useLargeTableCells="useLargeTableCells"
  />
</template>

<script>
import {
  ApplePackageManagers,
  ItemTableConsts,
  ItemTypeConsts,
  StoreModuleMap,
} from 'client/util/Constants';
import { mapActions } from 'vuex';
import AppleVppSupportedDevices from 'client/components/ItemTable/BodyComponents/AppleVppSupportedDevices.vue';
import ItemTable from 'client/components/ItemTable/ItemTable.vue';
import ItemTableComputedMixin from 'client/components/ItemTable/mixins/ItemTableComputedMixin';
import SoftwareAppsStatusLabel from 'client/components/ItemTable/BodyComponents/SoftwareAppsStatusLabel.vue';
import VppAppIcon from 'client/components/ItemTable/BodyComponents/VppAppIcon.vue';

const { columnTypes } = ItemTableConsts;
const deviceAppStatusCollection = StoreModuleMap[ItemTypeConsts.deviceAppStatus];

export default {
  name: 'DeviceAppStatusItemTable',

  components: {
    ItemTable,
  },

  mixins: [ItemTableComputedMixin],

  props: {
    systemId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      details: false,
      disableBoundCount: true,
      emptyCollectionMessage: 'No app status results available',
      idField: 'status.id',
      inDetailsAsidePanel: true,
      inPanel: false,
      itemType: ItemTypeConsts.deviceAppStatus,
      legacyRowStyles: false,
      showSearchForm: true,
      useLargeTableCells: false,
      columns: [
        {
          bodyComponent: VppAppIcon,
          bodyComponentProps: {
            iconField: 'app.settings[0].appleVpp.details.artwork.url',
          },
          classNames: {
            body: [columnTypes.iconColumn],
          },
        },
        {
          bodyComponent: 'ItemName',
          bodyComponentProps: {
            indirectItem: 'app',
            titleField: 'app.displayName',
          },
          headingText: 'Name',
        },
        {
          dataField: 'app.settings[0].location',
          headingText: 'Location',
        },
        {
          headingText: 'Device Family',
          bodyComponent: AppleVppSupportedDevices,
          bodyComponentProps: {
            arrayField: 'app.settings[0].appleVpp.supportedDeviceFamilies',
          },
        },
        {
          bodyComponent: SoftwareAppsStatusLabel,
          bodyComponentProps: {
            inDevicesAside: true,
          },
          headingText: 'Status',
        },
      ],
    };
  },

  computed: {
    getCollectionFilters() {
      return [
        {
          name: 'packageManager',
          operator: 'in',
          value: Object.values(ApplePackageManagers).join('|'),
        },
      ];
    },
  },

  mounted() {
    this.setSystemId(this.systemId);
  },

  methods: {
    ...mapActions(deviceAppStatusCollection, ['setSystemId']),
  },
};
</script>
